import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="py-5 bg-background-50 border-b border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center gap-2 overflow-x-auto pb-1 scrollbar-hide flex-wrap">
          <span className="text-sm font-semibold text-foreground-700 mr-2 whitespace-nowrap flex-shrink-0">
            <i className="ri-apps-2-line mr-1"></i>
            全部分类:
          </span>
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={cat.slug === 'all' ? '/category/all' : `/category/${cat.slug}`}
              className="flex items-center gap-1.5 px-3.5 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap flex-shrink-0 cursor-pointer bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-700"
            >
              <i className={`${cat.icon} text-sm`}></i>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}